import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberSuffix'
})
export class NumberSuffixPipe implements PipeTransform {

  transform(value:string | number | null): string{
    if (value == null) return '-';

    if(typeof value === 'string') value = Number(value);

    if (value < 1000) return value.toString();

    const suffixes = ['', 'K', 'M', 'B', 'T']; 
    const tier = Math.floor(Math.log10(value) / 3);

    if (tier === 0) return value.toString();

    const suffix = suffixes[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = value / scale;

    return scaled.toFixed(1).replace(/\.0$/, '') + suffix;
    
  }

}


